import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
    // Using an object to track open states of multiple FAQs
    const [openQuestions, setOpenQuestions] = useState({});

    const toggleQuestion = (index) => {
        setOpenQuestions(prevOpenQuestions => ({
            ...prevOpenQuestions,
            // Toggle the state for the clicked question
            [index]: !prevOpenQuestions[index]
        }));
    };

    // Array of questions and answers
    const faqData = [
        {
            question: "What is Boost Interview?",
            answer: "Boost Interview is a mock interview platform offering access to 15,000+ questions from 30+ companies and 180+ positions. Users can practice their interview skills, receive AI-generated feedback, and enhanced answers to improve interview skills by practicing questions that appeared in previous real interviews and land their dream job."
        },
        {
            question: "How can I sign up for Boost Interview?",
            answer: "You can sign up for Boost Interview by using your normal email address. Simply follow the prompts on the sign-up page to get started."
        },
        {
            question: "What are the differences between the free version and the premium version of Boost Interview?",
            answer: "The free version offers access to a limited set of questions, allows users to vote like or dislike, add questions to their list, filter questions by positions, and submit answers for scoring and feedback on up to 5 questions. The premium version provides access to all questions, includes filtering by company and position, removes the limitation on the number of questions submitted for feedback, and offers AI-enhanced response based on users' answers."
        },
        {
            question: "Can I see the history of questions I submitted and its feedback?",
            answer: "Yes, after registering and signing in, you can access the history of your previously submitted questions and your scores in the 'My Submissions' section under your account page. When you click on the questions, you can see detailed responses and the corresponding feedback. This feature enables you to track your progress, observe improvements, and identify areas that may still need work."
        },
        {
            question: "What is the cost of the premium subscription service?",
            answer: "Our premium service costs $25 per month. However, we offer a discounted rate of $12.50 per month if you opt for our yearly plan, amounting to $150 annually, which is a 50% discount compared to the monthly plan. For detailed information, including promotional offers, please visit the Premium Page."
        },
        {
            question: "How can I change from the monthly plan to the yearly plan, and when will it take effect?",
            answer: "You can easily change from the monthly plan to the yearly plan by selecting 'My Orders' under your account to manage your subscription. When you update to the yearly plan, the new plan will take effect immediately. The amount you will be required to pay is the remaining amount after deducting the prorated monthly amount from the yearly plan's total cost."
        },
        {
            question: "Can I cancel my subscription at any time?",
            answer: "Yes, you can cancel your premium subscription at any time without any penalties. The subscription auto-renews each month or year depending on the plan you selected."
        },
        {
            question: "What happens to my account if I cancel my premium subscription?",
            answer: "If you cancel your premium subscription, your account will revert to the standard account status. You'll lose access to premium features until the current premium period ends."
        },
        {
            question: "Are there any refunds available if I choose to cancel my subscription early?",
            answer: "Our policy does not support refunds for partial months or years. If you cancel early, you will retain premium access until the end of your current billing cycle."
        },
        {
            question: "How soon after my payment will I gain access to the premium features?",
            answer: "You will gain immediate access to the premium features as soon as your payment is processed successfully."
        },
        {
            question: "How secure is my payment information?",
            answer: "The protection of your personal information is a priority for us. To safeguard your payment details, we utilize advanced security protocols and measures, ensuring they remain protected and confidential."
        },
        {
            question: "How does Boost Interview handle my personal information?",
            answer: "Your privacy is of utmost importance at Boost Interview. We adhere strictly to privacy regulations and our own Privacy Policy when processing your personal data, using it solely to improve our services and your experience. Your personal information is not sold or distributed to third parties that are not related to us. To assist in the management and operation of our platform, we might share your data with service providers, strictly following the guidelines outlined in our Privacy Policy and only to the extent necessary."
        },
        {
            question: "How can I delete my account or my data?",
            answer: "Should you wish to have your account or personal data deleted, please reach out to contact us by email. We will process your deletion request in line with relevant legal requirements and our Privacy Policy, ensuring your data is handled appropriately."
        }
    ];

    return (
        <div className="faq-container">
            <h1 className="faq-title">Frequently asked questions</h1>
            <p className="faq-description">
                Here's a list of frequently asked questions. If you have any other questions please reach out to us at <a href="mailto:boostinterview.help@gmail.com">boostinterview.help@gmail.com</a>.
            </p>
            {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                    <button className={`faq-question ${openQuestions[index] ? 'active' : ''}`} onClick={() => toggleQuestion(index)}>
                        {faq.question}
                        <span className="faq-toggle">{openQuestions[index] ? '-' : '+'}</span>
                    </button>
                    <div className={`faq-answer ${openQuestions[index] ? 'active' : ''}`}>
                        {faq.answer}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default FAQ;
